module.exports = __webpack_public_path__ + "img/P150T_weapon_88.56af4b0c.png";